export default __webpack_public_path__ + "static/Tek_Turret-97e9536675dba06ab929686a2cb11e17.png";